module.exports = __webpack_public_path__ + "media/table_tent.c075d391.webm";